// state
const state = {
    active: true,
    langs: {},
    lang: 'fr'
}

// getters
const getters = {}

// actions
const actions = {}
 
// mutations
const mutations = {
	
    setLang(state, value) {
        state.lang = value
    },

    setLangs(state, value) {
        state.langs = value
    },

    setActive(state, value) {
        state.active = value
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}